<template>
    <v-card>
        <v-card-title class="primary white--text headline">
            {{title}}
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
            <v-select v-model="selectedEquip" :items="equipmentNames" label="Equipment">
            </v-select>
        </v-card-text>
        <v-layout row wrap v-if="data">
            <v-flex xs12 lg6 v-for="equip in data" v-if="equip.equip==selectedEquip">
                <vue-plotly disable-responsive :data="equip.data" :layout="equip.layout" :options="{}"/>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    import VuePlotly from '@/components/VuePlotly'
    import {getResult} from '@/helper'

    export default {
        name: 'PowerForecast',
        components: {VuePlotly},
        computed: {
            facilityName() {
                return this.$store.state.pointsListStore.pointsList.facility_name;
            },

        },
        data() {
            return {
                loading: true,
                selectedEquip: null,
                equipmentNames: [],
                data: []
            }
        },
        props: {
          yaxis: {type: String, default: 'predicted_comp_power'},
          zaxis: {type:String, default: null},
          title: {type:String, default: 'Power Prediction'}
        },
        methods: {},
        mounted() {
            let me = this;
            getResult({
                facility_name: me.facilityName,
                result_name: 'Power Prediction'
            }).then(function (res) {
                let result = res.result[0].content.result
                let data = []
                let equipmentNames = []
                for (let equip in result) {
                  equipmentNames.push(equip)

                  if (me.zaxis) {
                    data.push({
                        "equip": equip,
                        "layout": {
                          "scene": {
                            xaxis: {title: "Actual Power"},
                            yaxis: {title: me.yaxis},
                            zaxis: {title: me.zaxis}
                          },
                          title: equip,
                        },
                        "data": [
                            {
                                x: result[equip].actual_comp_power,
                                y: result[equip][me.yaxis],
                              z: result[equip][me.zaxis],
                                hovertext: result[equip].timestamp,
                              marker: {
                                  opacity: 0.2,
                                size:2
                              },
                                type:"scatter3d",
                                mode: "markers",
                            },
                        ]
                    })
                  } else {
                    data.push({
                        "equip": equip,
                        "layout": {
                            title: equip,
                            xaxis: {title: "Actual Power"},
                            yaxis: {title: "Predicted Power"},
                        },
                        "data": [
                            {
                                x: result[equip].actual_comp_power,
                                y: result[equip][me.yaxis],
                                hovertext: result[equip].timestamp,
                                type:"scattergl",
                                mode: "markers",
                            },

                        ]
                    })
                  }

                }
                me.equipmentNames = equipmentNames
                me.selectedEquip = equipmentNames[0]
                me.data = data
                me.loading = false
            });
        }

    }
</script>

<style scoped>

</style>
